<template>
    <div>

        <!-- Nog niet afgesloten montages -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-briefcase"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Montages
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#staleAssemblies" aria-expanded="true" aria-controls="staleAssemblies">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="staleAssemblies">

                <div
                    class="messages"
                    v-if="this.items.length !== 0"
                >
                    <div
                        v-for="item in this.items"
                        class="message"
                    >
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">{{ item.order_id }} | {{ item.name }}</p>
                                <span class="date ms-sm-auto text-end">Laatste montagedatum:<br>{{ item.last_assembly_date }}</span>
                            </div>
                        </div>
                        <div class="actions">
                            <a v-if="item.order_type == 'order'" :href="'assemblies/show/order/'+item.order_id" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                            <a v-if="item.order_type == 'order-project'" :href="'assemblies/show/order-project/'+item.order_id" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'stale-assemblies',
        components: {},
        props: {},
        data() {
            return {
                items: [{
                    key: {
                        planning_assembly_id: '',
                        end_question_id: '',
                        team_id: '',
                        order_id: '',
                        name: '',
                        city: '',
                        id_dossier: '',
                        order_type: '',
                        last_assembly_id: '',
                        last_assembly_date: '',
                    }
                }],

                componentId: null,
                componentIsVisable: false,
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });
            },
            getStaleAssemblies() {
                axios.get('api/stale-assemblies')
                    .then(response => {
                       this.items = response.data.items;

                        this.componentId = response.data.componentId;
                        this.componentIsVisable = response.data.componentIsVisable;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
        },
        mounted() {
            this.getStaleAssemblies();
        },
        created() {},
    }
</script>
